import { OctagonAlertIcon } from "lucide-react";

type ErrorMessageProps = {
  error?: string | undefined;
  showNoCreditsMessage?: boolean;
};

export function ErrorMessage({ error, showNoCreditsMessage = false }: ErrorMessageProps) {
  if (!error && !showNoCreditsMessage) {
    return null;
  }

  return (
    <div className="mt-1 flex items-center gap-3 rounded-lg border border-orange-200 bg-orange-50 px-2 py-1">
      <OctagonAlertIcon className="size-6 text-orange-600" />
      <p className="text-xs font-normal text-gray-700">
        {error || "You've used all your daily credits. More credits will be available tomorrow."}
      </p>
    </div>
  );
}
